import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import { Link } from '@material-ui/core';
import { LanguageItemProps } from './interface';

export const LanguageItem: FC<LanguageItemProps> = ({
  language,
  onLanguageChange,
  i18n,
}) => {
  return (
    <Box component="span">
      <Link
        style={{
          fontWeight: i18n.language.startsWith(language) ? 'bold' : 'normal',
        }}
        href="#"
        onClick={() => {
          i18n.changeLanguage(language).then(() => {
            if (onLanguageChange) {
              onLanguageChange(language);
            }
          });
        }}
      >
        {language.toUpperCase()}
      </Link>
    </Box>
  );
};
